/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AccountPlanOccurrence = {
    YEARLY: 'YEARLY',
    MONTHLY: 'MONTHLY'
} as const;
export type AccountPlanOccurrence = typeof AccountPlanOccurrence[keyof typeof AccountPlanOccurrence];

